import { RootState } from 'data/root.reducers';
import { EWarrant, EWarrantGridRowData } from './eWarrant.types';

export const getEWarrantList = (state: RootState): EWarrant[] =>
  state.eWarrant.entities;

export const getSelectedEWarrants = (state: RootState): EWarrantGridRowData[] =>
  state.eWarrant.selected;

/**
 * The full e-warrant behind the currently selected grid row. The grid only
 * carries the summary fields, so the view page resolves the detail from here.
 */
export const getSelectedEWarrant = (state: RootState): EWarrant | undefined => {
  const [selected] = state.eWarrant.selected;

  if (selected == null) {
    return undefined;
  }

  return state.eWarrant.entities.find(({ id }) => id === selected.id);
};

export const isLoadingEWarrants = (state: RootState): boolean =>
  state.eWarrant.ui.isLoading;
